/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_Status_ApprovedInputs */

const en_us2_board_status_approved = /** @type {(inputs: Board_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

const pt_br2_board_status_approved = /** @type {(inputs: Board_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicada`)
};

const pt_pt2_board_status_approved = /** @type {(inputs: Board_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicada`)
};

/** @type {(inputs: Board_Status_ApprovedInputs) => LocalizedString} */
const es_419_board_status_approved = en_us2_board_status_approved;

/** @type {(inputs: Board_Status_ApprovedInputs) => LocalizedString} */
const fr_fr2_board_status_approved = en_us2_board_status_approved;

/** @type {(inputs: Board_Status_ApprovedInputs) => LocalizedString} */
const de_de2_board_status_approved = en_us2_board_status_approved;

/** @type {(inputs: Board_Status_ApprovedInputs) => LocalizedString} */
const it_it2_board_status_approved = en_us2_board_status_approved;

/**
* | output |
* | --- |
* | "Published" |
*
* @param {Board_Status_ApprovedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_status_approved = /** @type {((inputs?: Board_Status_ApprovedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_Status_ApprovedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_status_approved(inputs)
	if (locale === "es-419") return es_419_board_status_approved(inputs)
	if (locale === "pt-PT") return pt_pt2_board_status_approved(inputs)
	if (locale === "fr-FR") return fr_fr2_board_status_approved(inputs)
	if (locale === "de-DE") return de_de2_board_status_approved(inputs)
	if (locale === "it-IT") return it_it2_board_status_approved(inputs)
	return en_us2_board_status_approved(inputs)
});
export { board_status_approved as "board.status_approved" }